/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { equityInvestmentPageVisitedGetResponseSchema } from './equityInvestmentPageVisitedGetResponseSchema.ts';

/**
 * @description 200 response
 */
export const getEquityInvestmentPageVisited200Schema = z.lazy(() => equityInvestmentPageVisitedGetResponseSchema);

/**
 * @description 505 response
 */
export const getEquityInvestmentPageVisited505Schema = z.any();

export const getEquityInvestmentPageVisitedQueryResponseSchema = z.lazy(() => getEquityInvestmentPageVisited200Schema);
